// import formatTimestamp from './formatTimestamp';

export const formatSimpleLocalTime = (date) =>
	date && new Date(date).toLocaleTimeString().replace(/:\d+\s/, ' ');
// date && formatTimestamp(date, { timeOnly: true });
